module.exports = __webpack_public_path__ + "static/noobw-logo-subtitle-943293bc1e801d7d244f61a7fee221bd.svg";